import { useTranslate } from '@tolgee/react';
import { EmployeeStatusEnum } from 'abi-lcm-common-types';

import {
  EmployeeProfileSeverity,
  type EmployeeProfileSeverityType,
} from '~/shared/components/EmployeeProfile/ProfileContainer';

type EmployeeStatusWarning = {
  severity: EmployeeProfileSeverityType;
  message: string;
  backgroundColor: string;
};
export function useEmployeeStatusWarning() {
  const { t } = useTranslate('default');

  const getWarningConfig = (
    status?: string
  ): EmployeeStatusWarning | undefined => {
    if (status === EmployeeStatusEnum.WITHDRAWN) {
      return {
        severity: EmployeeProfileSeverity.WARNING,
        message: t('attention_tooltip.terminated'),
        backgroundColor: '#FFFCE8',
      };
    }

    return undefined;
  };

  return { getWarningConfig };
}
